import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { parseConfig } from '../../shared/config';
import ScriptLoader from '../../client/service/ScriptLoader';

export const BARE_MAP_STYLE = [
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

export const buildMarker = ({ googleMaps = window?.google?.maps, mapRef, lat, lng }) => {
  const MARKER_URL = '/listing-ui-assets/img/map-marker.svg';

  new googleMaps.Marker({ // eslint-disable-line no-new
    position: {
      lat,
      lng,
    },
    map: mapRef,
    animation: googleMaps.Animation.DROP,
    icon: {
      scaledSize: new googleMaps.Size(22, 31),
      origin: new googleMaps.Point(0, 0),
      anchor: new googleMaps.Point(11, 31),
      url: MARKER_URL,
    },
  });
};

const Map = ({ options, onMount, className }) => {
  const divProps = { ref: useRef(), className };

  const loadGoogleScript = (callback) => {
    const {
      GOOGLE_MAPS_CLIENT_ID,
      GOOGLE_MAPS_CHANNEL,
    } = parseConfig();
    const GOOGLE_MAPS_SCRIPT_URL = `https://maps.googleapis.com/maps/api/js?client=${GOOGLE_MAPS_CLIENT_ID}&channel=${GOOGLE_MAPS_CHANNEL}`;

    ScriptLoader.loadScript(GOOGLE_MAPS_SCRIPT_URL, callback);
  };

  useEffect(() => {
    const callback = () => {
      const googleMaps = window.google?.maps;
      const map = new googleMaps.Map(divProps.ref.current, options);

      onMount?.(map); // eslint-disable-line no-unused-expressions
    };

    if (!window.google) {
      return loadGoogleScript(callback);
    }

    return callback();
  }, [divProps.ref, onMount, options]);

  return (
    <div {...divProps} />
  );
};

Map.propTypes = {
  options: PropTypes.shape({
    center: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }).isRequired,
    zoom: PropTypes.number.isRequired,
  }).isRequired,
  onMount: PropTypes.func,
  className: PropTypes.string,
};

export default Map;
